var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.469 2.969c.289.289.531.867.531 1.281v9a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V.75A.75.75 0 01.75 0h7c.414 0 .992.242 1.281.531zM8 1.062v2.937h2.937a.98.98 0 00-.172-.32L8.32 1.234A.991.991 0 008 1.062zM11 13V5H7.75A.75.75 0 017 4.25V1H1v12h10zM1.82 6v.836h.547L3.648 12H4.89l1-3.789c.039-.117.062-.234.078-.359.008-.062.016-.125.016-.187h.031l.023.187c.023.109.031.234.07.359l1 3.789H8.35l1.281-5.164h.547V6H7.834v.836h.703l-.773 3.422a2.298 2.298 0 00-.055.359l-.016.164h-.031c0-.047-.016-.109-.023-.164-.023-.102-.039-.234-.07-.359L6.444 6h-.891l-1.125 4.258c-.031.125-.039.258-.062.359l-.031.164h-.031l-.016-.164a2.17 2.17 0 00-.055-.359L3.46 6.836h.703V6H1.819z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordFile);
export default __webpack_public_path__ + "static/media/WordFile.1695f13bf43f4c4a5969b5d0ca7ee679.svg";
export { ForwardRef as ReactComponent };